











import { Component, Vue } from "vue-property-decorator";

@Component
export default class HandbookLayout extends Vue {
  isInPath(check: string) {
    return this.$route.path.includes(check);
  }
}
